/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

type Zahlungstyp = "KEINE" | "KARTE" | "GIROPAY" | "SEPA" | "AUFRECHNUNG" | "PAYPAL";

export default Zahlungstyp;

export class ZahlungstypSammlung {
    public static readonly keine: Zahlungstyp = "KEINE";
    public static readonly karte: Zahlungstyp = "KARTE";
    public static readonly giropay: Zahlungstyp = "GIROPAY";
    public static readonly sepa: Zahlungstyp = "SEPA";
    public static readonly aufRechnung: Zahlungstyp = "AUFRECHNUNG";
    public static readonly paypal: Zahlungstyp = "PAYPAL";
}
